var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaceSad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.37769 21.6529C5.12669 20.5011 2 16.6157 2 12C2 6.47738 6.47691 2 12 2C17.5226 2 22 6.47738 22 12C22 16.6621 18.8094 20.5792 14.493 21.687",
    stroke: "#EA6D6F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.69495 15.9036C8.69495 15.9036 11.7397 13.0137 15.3049 15.9036",
    stroke: "#EA6D6F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6881 10.6147C16.1762 10.6147 16.5715 10.2196 16.5715 9.73125C16.5715 9.24236 16.1757 8.84687 15.6881 8.84687C15.2006 8.84687 14.8042 9.24279 14.8042 9.73125C14.8042 10.2191 15.2 10.6147 15.6881 10.6147Z",
    fill: "#EA6D6F",
    stroke: "#EA6D6F",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.31189 10.6147C8.80002 10.6147 9.19532 10.2196 9.19532 9.73125C9.19532 9.24236 8.79945 8.84687 8.31189 8.84687C7.82437 8.84687 7.42798 9.24279 7.42798 9.73125C7.42798 10.2191 7.82381 10.6147 8.31189 10.6147Z",
    fill: "#EA6D6F",
    stroke: "#EA6D6F",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceSad);
export default __webpack_public_path__ + "static/media/face-sad.721b4f5fb5f6d3603fa7c6376e65faa3.svg";
export { ForwardRef as ReactComponent };